var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import { useEffect, useRef, useState, createElement } from '@max/max';
import { useConfirm } from '@/hooks/useConfirm';
import LImage from '@max/leez-image';
import LinearGradient from '@hfe/max-linear-gradient';
import './index.scss';
import Button from '@hfe/max-button';
import Avatar from '@/components/avatar';
const isMRN = false;
import LText from '@max/leez-text';
import { Animated } from '@max/mbc-animated';
import AnimatedView from '@max/mbc-animate-view';
import { PanResponder } from '@max/mbc-panresponder';
import PanView from '@max/mbc-pan-view';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { getFullScreenSize } from '@/utils/layout';
import { getRandomTag, MTNewDigitalDisplayStyle } from '@/utils/common';
import Sensor from '@max/mbc-sensor';
import { BID_MAP } from '@/const';
import { TeamRecommendTheme } from '@/theme/main';
import { rpx2px } from '@hfe/max-universal-unit-tool';
import PointerVapContainer from '@/components/pointer-vap-container';
export default function TeamRecommend(props) {
    const ctx = useMonitorEngineContext();
    const { recTeamList: _recTeamList, inviteTeamInfo } = props;
    const rawRecTeamList = Array.isArray(_recTeamList) ? _recTeamList : [];
    const recTeamList = inviteTeamInfo ? [Object.assign(Object.assign({}, inviteTeamInfo), { isInvite: true }), ...rawRecTeamList] : rawRecTeamList;
    const [openTeamChecked, setOpenTeamChecked] = useState(true);
    const [scrollY] = useState(new Animated.Value(0));
    const currentScrollY = useRef(0);
    const { toRateSize } = getFullScreenSize();
    const { openConfirm, closeConfirm } = useConfirm();
    function handleCreateTeam() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!openTeamChecked) {
                // 二次确认
                openConfirm({
                    title: '确认创建一个不公开的战队吗？',
                    content: '不公开的战队，只有战队内的成员可以邀请其他好友加入，排名不受影响',
                    onConfirm: () => __awaiter(this, void 0, void 0, function* () {
                        yield props.onCreateTeam(openTeamChecked);
                        closeConfirm();
                    }),
                    onCancel: () => {
                        closeConfirm();
                    }
                });
            }
            else {
                yield props.onCreateTeam(openTeamChecked);
            }
        });
    }
    function handleJoinTeam(groupId, leaderId) {
        return __awaiter(this, void 0, void 0, function* () {
            scrollY.stopAnimation();
            openConfirm({
                title: '确认加入战队吗？',
                content: '加入战队后，您可以邀请其他好友加入，一起完成任务，获得奖励。',
                onConfirm: () => __awaiter(this, void 0, void 0, function* () {
                    yield props.onJoinTeam(groupId, leaderId);
                    closeConfirm();
                }),
                onCancel: () => {
                    closeConfirm();
                }
            });
        });
    }
    const topActions = [{
            icon: TeamRecommendTheme.TopActionJoinIcon,
            text: '加入或创建队'
        }, {
            icon: TeamRecommendTheme.TopActionInviteIcon,
            text: '邀好友助力'
        }, {
            icon: TeamRecommendTheme.TopActionWinIcon,
            text: '一起赢免单'
        }];
    const teamListLength = Array.isArray(recTeamList) && recTeamList.length || 0;
    const MAX_SCROLL_Y = -toRateSize(115 * (teamListLength - 2 || 0)) - 5;
    const SCROLL_BOUNCE_LENGTH = -toRateSize(115);
    const panResponder = PanResponder.create({
        onStartShouldSetPanResponder: () => {
            ctx._pageAPI.disableScroll();
            return false;
        },
        onStartShouldSetPanResponderCapture: () => {
            ctx._pageAPI.disableScroll();
            return false;
        },
        onMoveShouldSetPanResponder: (_, gesture) => {
            const isHasScroll = gesture.dx !== 0;
            return isHasScroll;
        },
        onPanResponderRelease: () => {
            ctx._pageAPI.enableScroll();
            currentScrollY.current = scrollY.__getValue();
            if (currentScrollY.current < MAX_SCROLL_Y) {
                Animated.spring(scrollY, {
                    toValue: teamListLength <= 3 ? 0 : MAX_SCROLL_Y,
                    useNativeDriver: true,
                    stiffness: 100,
                    damping: 10,
                    mass: 0.5,
                    overshootClamping: true
                }).start();
                currentScrollY.current = MAX_SCROLL_Y;
            }
            else if (currentScrollY.current > 0) {
                Animated.spring(scrollY, {
                    toValue: 0,
                    useNativeDriver: true,
                    stiffness: 100,
                    damping: 10,
                    mass: 0.5,
                    overshootClamping: true
                }).start();
                currentScrollY.current = 0;
            }
        },
        onPanResponderMove: (_, gestureState) => {
            ctx._pageAPI.disableScroll();
            scrollY.stopAnimation();
            const dy = gestureState.dy;
            const newY = currentScrollY.current + dy;
            if (newY >= MAX_SCROLL_Y + SCROLL_BOUNCE_LENGTH) {
                scrollY.setValue(newY);
            }
            else if (newY <= Math.abs(SCROLL_BOUNCE_LENGTH)) {
                scrollY.setValue(newY);
            }
            else {
                // empty
            }
        }
    });
    useEffect(() => {
        if (Array.isArray(recTeamList) && recTeamList.length > 3) {
            Animated.timing(scrollY, {
                toValue: MAX_SCROLL_Y,
                duration: (Array.isArray(recTeamList) && recTeamList.length - 3 || 0) * 2500,
                useNativeDriver: true,
                easing: Animated.Easing.linear
            }).start();
            currentScrollY.current = MAX_SCROLL_Y;
        }
        return () => {
            scrollY.stopAnimation();
        };
    }, []);
    return <>
      <LImage source={{
        uri: TeamRecommendTheme.BackgroundImage
    }} style={{
        width: '702rpx',
        height: '591rpx'
    }} borderRadius={rpx2px(36)} resizeMode="stretch" className='team-recommend-bg'>
        <View className="team-recomment-wrap">
          <Image source={{
        uri: TeamRecommendTheme.TitleHeaderImage
    }} style={{
        width: '319rpx',
        height: '52rpx'
    }}/>
          
          <View className='team-recommend-top-actions'>
            {topActions.map((item, index) => <>
                  <View key={item.text} className='team-recommend-top-actions-item'>
                    <LImage source={{
        uri: item.icon
    }} style={{
        width: '40rpx',
        height: '40rpx'
    }}/>
                    <Text className='team-recommend-top-actions-text'>{item.text}</Text>
                  </View>
                  <Image x-if={index !== topActions.length - 1} source={{
        uri: TeamRecommendTheme.TopActionArrow
    }} style={{
        width: '8rpx',
        height: '13.6rpx',
        marginLeft: '25.75rpx',
        marginRight: '25.75rpx'
    }}/>
                </>)}
          </View>
          <View className='team-recommend-top-action-spliter-line'/>
          {inviteTeamInfo && <TeamRecommendItem key={inviteTeamInfo.groupId} item={inviteTeamInfo} onJoinTeam={handleJoinTeam} isLast={true} style={{
        position: 'absolute',
        top: '120rpx',
        left: 0
    }} lxReport={props.lxReport} tag='好友战队' callValueDesc={props.callValueDesc}/>}

          
          <PanView className='team-recommend-list' panHandlers={panResponder.panHandlers} style={{
        marginTop: inviteTeamInfo ? '121rpx' : '12rpx'
    }}>
            <AnimatedView viewId="team-recommend-list" style={{
        transform: [{
                translateY: scrollY
            }],
        position: 'relative'
    }}>
              {Array.isArray(recTeamList) && recTeamList.length > 0 ? <>
                    {rawRecTeamList.map((item, index) => <TeamRecommendItem key={item.groupId} item={item} onJoinTeam={handleJoinTeam} isLast={index === rawRecTeamList.length - 1} style={{
        marginBottom: index === rawRecTeamList.length - 1 ? '204rpx' : '0rpx'
    }} lxReport={props.lxReport} callValueDesc={props.callValueDesc}/>)}
                  </> : <View style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '30rpx'
    }}>
                      <LImage source={{
        uri: TeamRecommendTheme.EmptyImage
    }} style={{
        width: '220rpx',
        height: '220rpx',
        marginBottom: '25rpx'
    }}/>
                      <LText type="body4" color="#888888">暂无推荐队伍</LText>
                    </View>}
            </AnimatedView>
          </PanView>

          <View className='team-recommend-list-footer'>
            <LinearGradient start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }} colors={['#FFFFFF00', '#FFFFFF']} className='team-recommend-list-footer-gradient'/>
            <View className='team-recommend-list-footer-image'>
              <Sensor once onAppear={() => {
        props.lxReport(BID_MAP.TEAM_CREATE_MV);
    }}>
                <PointerVapContainer onPress={handleCreateTeam} style={{
        right: '-10rpx',
        bottom: '-18rpx'
    }}>
                  <View 
    // onClick={handleCreateTeam}
    style={{
        marginLeft: '24rpx',
        marginRight: '24rpx'
    }}>
                    <LImage source={{
        uri: TeamRecommendTheme.CreateTeamButton
    }} style={{
        width: '654rpx',
        height: '110rpx'
    }}/>
                  </View>
                </PointerVapContainer>
              </Sensor>
            </View>
            <Button className='team-recommend-list-checkbox' onPress={() => {
        setOpenTeamChecked(!openTeamChecked);
    }}>
              <View className='team-recommend-list-checkbox-icon' style={{
        backgroundColor: openTeamChecked ? '#FFD109' : '#C2C2C2'
    }}>
                <Image x-if={openTeamChecked} source={{
        uri: TeamRecommendTheme.CheckboxCheckedIcon
    }} style={{
        width: '15.95rpx',
        height: '11.75rpx'
    }}/>
              </View>
              <Text className='team-recommend-list-checkbox-text'>
                将队伍推荐给他人，陌生人可加入
              </Text>
            </Button>
          </View>
        </View>
      </LImage>
    </>;
}
function TeamRecommendItem(props) {
    const { item, onJoinTeam, style, isLast, tag } = props;
    return <View key={item.groupId} className='team-recommend-item' style={style}>
    <View className='team-recommend-item-left'>
      <Avatar avatar={item.teamImg}/>
      <View className='team-recommend-item-info'>
        <View className="team-info-name-wrap">
          <Text className='team-recommend-item-team-name' style={MTNewDigitalDisplayStyle} numberOfLines={1}>{item.teamName}</Text>
          <Text className='team-recommend-item-member-count'>（{item.memberCount}/{item.maxMemberCount}人）</Text>
          <View className='team-recommend-item-tag'>
            <Text className='team-recommend-item-tag-text' style={{
        lineHeight: isMRN ? '24rpx' : '20rpx'
    }}>{tag || getRandomTag(item.groupId)}</Text>
          </View>
        </View>
        <View className="item-call-wrap">
          <LImage source={{
        uri: TeamRecommendTheme.CallIcon
    }} style={{
        width: '20rpx',
        height: '28rpx'
    }}/>
          <Text className='team-recommend-item-call-value'>{props.callValueDesc || '心愿值'}：{item.teamValue || 0}</Text>
        </View>
      </View>
    </View>
    <Sensor onAppear={() => {
        props.lxReport(BID_MAP.TEAM_JOIN_MV);
    }} once>
      <Button onPress={() => onJoinTeam(item.groupId, item.teamLeaderId)}>
        <View className='team-recommend-item-join-button'>
          <Text className='team-recommend-item-join-button-text'>加入</Text>
        </View>
      </Button>
    </Sensor>
    {!isLast && <View className='team-recommend-item-spliter-line'/>}
  </View>;
}
